import { selectReservation } from '@/core/reservation/store/reservation.selector';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ReservationGuard implements CanActivate {
    constructor(
        private store: Store,
        private router: Router,
    ) {}

    canActivate(): Observable<boolean> {
        return this.store.select(selectReservation).pipe(
            take(1),
            map((reservation) => {
                if (
                    reservation &&
                    typeof reservation === 'object' &&
                    Object.keys(reservation).length > 0
                ) {
                    return true;
                } else {
                    this.router.navigate(['/']);
                    return false;
                }
            }),
        );
    }
}
